/**
 *
 * @param {string} birthdate
 * @returns {boolean}
 */
export function validateBirthdate(birthdate) {
  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/
  if (regex.test(birthdate)) {
    return true
  }
  return false
}
